import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {BookingState} from '../types/booking-state';
import {AlertStateEnum, BookingStepsEnum} from '../enums/booking-enums';
import * as dayjs from 'dayjs';
import 'dayjs/locale/sv';

@Injectable({
  providedIn: 'any',
})
export class BookingV2StateService {
  public state$: BehaviorSubject<BookingState> = new BehaviorSubject(this.getDefaultState());
  public isCurrentRouteFromRedirect: boolean = false;
  public selectedDateTimeStorageFormat: string = 'YYYYMMDDHHmm';

  constructor() {
    dayjs.locale('sv');
  }

  public getDefaultState(): BookingState {
    return {
      providerId: null,
      serviceId: null,
      timeslot: null,
      step: 1,
      selectedBookingServiceId: null,
      selectedStaffMemberId: null,
      alert: AlertStateEnum.NORMAL,
      errorMessage: null,
      selectedDateTime: null,
      calendarWeekStartDate: dayjs().startOf('week').format('YYYY-MM-DD'),
      calendarWeekEndDate: dayjs().endOf('week').format('YYYY-MM-DD'),
      referral: '',
      showSummary: false,
      forceCalendarDate: false,
      numberOfTimeslots: 0,
      serviceGroup: null,
      TimeslotMatchExisted: null,
      twoFactorAuthenticationRequired: null,
    };
  }

  public resetState(): void {
    this.state$.next(this.getDefaultState());
  }

  public updateState(state: BookingState): void {
    state = this.updateShowSummary(state);
    this.state$.next(state);
  }

  public updateStateProperty(propertyName: string, propertyValue: any) {
    const state = this.state$.getValue();
    state[propertyName] = propertyValue;
    this.updateState(state);
  }

  private updateShowSummary(state: BookingState): BookingState {
    state.showSummary =
      state.step !== BookingStepsEnum.SERVICES &&
      state.selectedBookingServiceId !== this.getDefaultState().selectedBookingServiceId;
    return state;
  }
}
